// Adapted from AutoLoadItems.ts on raffinebridal.com

import convertToDoc from './convertToDoc';

interface AutoLoadPagesOptions {
	frameId: string; /** The results div */
	nextClass?: string;/** The class name of the next button */
	resultsClass: string; /** The class name of the item to be populated */
	paginationClass: string; /** The class name of the pagination element */
	loadMoreButtonText: string;
}

export default class AutoLoadPages {
	private options: AutoLoadPagesOptions;

	private resultsEl: HTMLElement;
	private paginationEl: HTMLElement;

	constructor(options: AutoLoadPagesOptions) {
		this.options = options;

		this.options.nextClass = options.nextClass || 'next';
		
		const loadMoreButtonLoader = (event: any) => {
			this.resultsEl = document.getElementById(this.options.frameId);
			this.paginationEl = document.getElementsByClassName(this.options.paginationClass)[0] as HTMLElement;

			// Nothing to setup
			if (!this.resultsEl || !this.paginationEl)
				return;
			if ((event !== null && event.detail.fireType !== 'always') || document.querySelector('button.loadMore') !== null)
				return;

			// Create "Load More Button"
			const loadMoreResultsEl = document.createElement('button');
			loadMoreResultsEl.className = 'loadMore';
			loadMoreResultsEl.innerHTML = this.options.loadMoreButtonText;
			this.paginationEl.appendChild(loadMoreResultsEl);

			document.getElementsByClassName('loadMore')[0].addEventListener('click', () => {
				this.loadNextPage();
			});

			this.paginationEl.classList.add('autoLoadPage');
		};
		loadMoreButtonLoader(null);
		document.addEventListener('jsfAjaxEvent', loadMoreButtonLoader);
	}

	private loadNextPage(): void {
		// Test no next page to load.
		if (!this.paginationEl)
			return;

		const nextEl = this.paginationEl.getElementsByClassName(this.options.nextClass)[0] as HTMLAnchorElement;
		if (!nextEl)
			return;

		let loadHref = nextEl.href;
		loadHref = loadHref.replace(/&?_=[0-9]+/, '');
		loadHref = loadHref.replace(/\?&/, '?');

		if (!loadHref)
			return;

		this.paginationEl.classList.add('autoLoadPage--isLoading');

		// Load next page
		const htmlAjaxAction = (response: string) => {
			const newPage: Document = convertToDoc(response);

			// Append new results
			const newItems = newPage.getElementById(this.options.frameId).getElementsByClassName(this.options.resultsClass);
			const newItemFragment = document.createDocumentFragment();

			for (let i = 0; i < newItems.length; i++) {
				newItemFragment.appendChild(document.importNode(newItems[i], true));
			}
			this.resultsEl.appendChild(newItemFragment);

			// Update pagination
			let newPagination = document.importNode(newPage.getElementsByClassName(this.options.paginationClass)[0], true);
			newPagination.classList.add('autoLoadPage');
			newPagination.appendChild(document.getElementsByClassName('loadMore')[0]);

			if (newPagination) {
				const paginationParentEl = this.paginationEl.parentElement;
				paginationParentEl.removeChild(this.paginationEl);
				this.paginationEl = paginationParentEl.appendChild(newPagination) as HTMLElement;

				const nextEl = this.paginationEl.getElementsByClassName(this.options.nextClass)[0];
				if (!nextEl) {
					this.paginationEl.classList.add('autoLoadPage--noNext');
				}
			} else {
				this.paginationEl.parentElement.removeChild(this.paginationEl);
				this.paginationEl = undefined;
			}
		};

		const doHtmlAjax = (handleResponse: any, requestUrl: string = window.location.href): void => {
			function status(response: Response): Promise<any> {
				if (response.ok) {
					return Promise.resolve(response);
				} else {
					return Promise.reject(new Error(response.statusText));
				}
			}

			fetch(requestUrl)
				.then(status)
				.then(response => response.text())
				.then(handleResponse)
				.catch(error => {
					console.warn(error);
				});
		};
		doHtmlAjax(htmlAjaxAction, nextEl.href);
	}
}